import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { BsModalRef } from 'ngx-bootstrap/modal';

@Component({
    selector: 'app-confirm-modal',
    templateUrl: './confirm-modal.component.html',
    styleUrls: ['./confirm-modal.component.scss'],
})
export class ConfirmModalComponent implements OnInit {
    @Output() confirmed = new EventEmitter<void>();

    constructor(public bsModalRef: BsModalRef, private router: Router) {}

    ngOnInit() {
        this.closeOnRouteChange();
    }

    public onConfirmClick(): void {
        this.confirmed.emit();
        this.bsModalRef.hide();
    }

    private closeOnRouteChange(): void {
        this.router.events.subscribe((evt) => {
            if (!(evt instanceof NavigationEnd)) {
                return;
            }
            this.bsModalRef.hide();
        });
    }
}
